import { signalStore } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { withSelectedEntity } from '../../shared/store/selected-entity.feature';
import { Activité } from '../models/activité.model';
import { avecMéthodesActivités } from './activité.methods';

export const ActivitéStore = signalStore(
  { providedIn: 'root' },
  withEntities<Activité>(),
  withSelectedEntity(),
  avecMéthodesActivités(),
);
